var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('horizontal-nav',{attrs:{"set_view":"","emitir_setSelected_al_inicio":"","show_display":false,"items":_vm.nav_items},on:{"setSelected":_vm.setSelectedView}}),_c('notas-de-credito'),_c('pagos-de-clientes')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }